import { BaseRepository } from "@/repositories/base-repository"
import { type IPerson } from "@/interfaces/api/person.interface"

export class PersonRepository extends BaseRepository<IPerson> {
  protected resourcePath = "core/persons"
}
